export default __webpack_public_path__ + "static/media/bw-name-vertical.2083e7ad.png";